// ----------------------------------------------------------------------
// <copyright file="Izenda.AppContext.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { assignAll } = require('lodash/fp');
  var PropTypes = require('react').PropTypes;
  var PageService = require('share/page/Izenda.PageService');
  var ValidationManager = require('share/validation/Izenda.ValidationManager');
  var DialogService = require('share/dialog/Izenda.DialogService');
  var SecurityManager = require('share/authorization/Izenda.SecurityManager');
  var AuthorizationConstants = require('logic/data/Izenda.AuthorizationConstants');
  var Localizer = require('share/localization/Izenda.Localizer');
  var ExportPageService = require('share/page/Izenda.ExportPageService');

  module.exports = {
    validationShape: {
      validation: PropTypes.object.isRequired
    },
    loaderShape: {
      loader: PropTypes.object.isRequired
    },
    dialogsShape: {
      dialogs: PropTypes.object.isRequired
    },
    authorizationShape: {
      authorization: PropTypes.object.isRequired
    },
    authorizationConstantsShape: {
      authorizationConstants: PropTypes.object.isRequired
    },
    localizationShape: {
      localization: PropTypes.object.isRequired
    },
    exportLoaderShape: {
      exportLoader: PropTypes.object.isRequired
    },
    createValidationContext: function() {
      return {
        validation: new ValidationManager()
      };
    },
    createLoaderContext: function() {
      return {
        loader: new PageService()
      };
    },
    createExportLoaderContext: function() {
      return {
        exportLoader: new ExportPageService()
      };
    },
    createDialogsContext: function() {
      return {
        dialogs: new DialogService()
      };
    },
    createAppContextShape: function() {
      return assignAll([
        this.validationShape,
        this.loaderShape,
        this.dialogsShape,
        this.authorizationShape,
        this.authorizationConstantsShape,
        this.localizationShape,
        this.exportLoaderShape
      ]);
    },
    createAuthorizationContext: function() {
      return {
        authorization: new SecurityManager()
      };
    },
    createAuthorizationConstantsContext: function() {
      return {
        authorizationConstants: AuthorizationConstants
      };
    },
    createLocalizerContext: function() {
      return {
        localization: Localizer
      };
    },
    createAppContext: function() {
      var validationContext = this.createValidationContext();
      var loaderContext = this.createLoaderContext();
      var dialogsContext = this.createDialogsContext();
      var authorizationContext = this.createAuthorizationContext();
      var authorizationConstantsContext = this.createAuthorizationConstantsContext();
      var localizerContext = this.createLocalizerContext();
      var exportLoaderContext = this.createExportLoaderContext();

      return assignAll([
        validationContext,
        loaderContext,
        dialogsContext,
        authorizationContext,
        authorizationConstantsContext,
        localizerContext,
        exportLoaderContext
      ]);
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/share/enhancers/Izenda.AppContext.js